module.exports = __webpack_public_path__ + "img/4ecd3d2.png";